import { WEB_API_ROUTES } from 'api/api-routes';
import { createThunk } from '../../utils/store-utils';
import { apiWrapper } from '../../api/apiWrapper';

export const thunks = {
  getClasses: createThunk('students/getClasses', (studentId) =>
    apiWrapper.get(WEB_API_ROUTES.class.list, {
      params: {
        student_id: studentId,
      },
    })
  ),

  getClassroom: createThunk('students/getClassroom', (classId) =>
    apiWrapper.get(WEB_API_ROUTES.class.classroom.replace('{classId}', classId))
  ),

  getNextAppointment: createThunk('students/getNextAppointment', (classId) =>
    apiWrapper.get(WEB_API_ROUTES.class.nextAppointment.replace('{classId}', classId))
  ),

  getPrevAppointment: createThunk('students/getPrevAppointment', (classId) =>
    apiWrapper.get(WEB_API_ROUTES.class.prevAppointment.replace('{classId}', classId))
  ),
};
